import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSimilarArticlesFailed, EGetSimilarArticlesActionType } from './types';

export const getSimilarArticlesFailed: () => TGetSimilarArticlesFailed =
  actionGenerator<EGetSimilarArticlesActionType.Failed>(EGetSimilarArticlesActionType.Failed);
